/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Component } from '@angular/core';

import { LoggingService, Logger } from 'crimson';
import { PlaytestLiveService } from '../core/services/playtest-live.service';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatDivider } from '@angular/material/divider';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
    NvAddKeyboardActivateDirective,
    CheckboxFocusMonitorDirective,
    OffDeviceLinkDirective,
    HyperLinkUserActivationGuardDirective
} from 'hig';

@Component({
    selector: 'nv-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [
        FlexModule,
        MatDivider,
        NvAddKeyboardActivateDirective,
        CheckboxFocusMonitorDirective,
        MatCheckbox,
        FormsModule,
        OffDeviceLinkDirective,
        HyperLinkUserActivationGuardDirective,
        MatButton
    ]
})
export class LoginComponent {
    private logger: Logger;
    checkboxState = false;

    constructor(
        private loggingService: LoggingService,
        private playtestLiveService: PlaytestLiveService
    ) {
        this.logger = this.loggingService.getLogger('LoginComponent');
    }

    onClickDoStarfleetLogin() {
        this.logger.info('### Initiate Starfleet Login');
        this.playtestLiveService.login();
    }
}
